// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"9261c38e","453":"3f427a95"}[chunkId] + ".chunk.js";
};